export const decodeJWT = (token) => {
  const payload = token ? JSON.parse(atob(token.split('.')[1])) : null;
  return payload || {};
};

export default {};
